import CryptoJS from 'crypto-js';

// Encryption key (in production, this should be in env variables)
const ENCRYPTION_KEY = 'perahouse-villa-booking-2025-secret-key';

// Encrypted OpenAI API key (pre-encrypted to avoid re-encryption on each load)
const ENCRYPTED_OPENAI_KEY = 'U2FsdGVkX1/Es+X+DbfDZ/23OE9ppnTpucc+aHf1ZD2K/FWbHIUxgdd+pXJ92O1MJqpW4NnObV4f0W+xzvS3clOu67tJIPbbDRdDUzXArHb6L5d2Ie1PBcFysmXUpjpVfT17mRHbZ7dZMW21EuG9+XN9VfL5Is4e5MbLcTq6NhtaDtEQ+KfqrVnrRROiA4bzQlglJzuUICP4XYWC6Pj7WbOHwmYpcQLZllHcspQsZ7sHBacCaxNbMXW25gL2Zhx0';

function decryptApiKey(encryptedKey: string): string {
  const bytes = CryptoJS.AES.decrypt(encryptedKey, ENCRYPTION_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
}

export function getOpenAIKey(): string {
  return decryptApiKey(ENCRYPTED_OPENAI_KEY);
}

export const config = {
  openai: {
    model: 'gpt-4o-mini',
    maxTokens: 500,
    temperature: 0.7,
  },
  chatbot: {
    name: 'Pera House Assistant',
    welcomeMessage: 'Hello! Welcome to Pera House Villa. How can I help you today?',
    languages: ['English', 'Greek', 'German', 'French', 'Spanish'],
  }
};
